import { Component, Input, OnInit } from '@angular/core';
import { IInvitation } from '@app/models/signup';
import { ConfigService, NotificationService } from '@infomaniak/angular-common';
import { translate } from '@ngneat/transloco';
import { InvitationB2bPartnerService, INVITATIONB2BPARTNERSTEPSTYPE, TInvitationB2BPartnerSteps } from './invitation-b2b-partner.service';

@Component({
  selector: 'app-invitation-b2b-partner',
  templateUrl: './invitation-b2b-partner.component.html',
  styleUrls: ['./invitation-b2b-partner.component.scss']
})
export class InvitationB2BPartnerComponent implements OnInit {
  @Input() invitation: IInvitation;

  rejectLoading = false;
  acceptLoading = false;
  invitationStep = INVITATIONB2BPARTNERSTEPSTYPE;
  currentInvitationStep: TInvitationB2BPartnerSteps = this.invitationStep.invitationB2bInit;
  partnershipId: number;

  constructor(
    private configService: ConfigService,
    private invitationB2bPartnerService: InvitationB2bPartnerService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit(): void {
    switch (this.invitation.status) {
      case 'pending':
        this.currentInvitationStep = this.invitationStep.invitationB2bInit;
        break;
      case 'accepted':
        this.currentInvitationStep = this.invitationStep.invitationB2bAlreadyAccepted;
        break;
      case 'rejected':
        this.currentInvitationStep = this.invitationStep.invitationB2bAlreadyRejected;
        break;
      case 'error':
        if (this.invitation.error_type && this.invitation.error_type === 'b2b_wrong_account') {
          this.currentInvitationStep = this.invitationStep.invitationB2bWrongAccount;
        } else if (this.invitation.error_type && this.invitation.error_type === 'b2b_only_for_owners') {
          this.currentInvitationStep = this.invitationStep.invitationB2bOnlyForOwners;
        } else {
          window.location.assign('auth/logout?with_login_redirect=1&redirect=' + window?.['ENDPOINTS']?.initial);
        }
        break;
      default:
        this.currentInvitationStep = this.invitationStep.invitationB2bInit;
        break;
    }
  }

  rejectInvitation(): void {
    this.rejectLoading = true;
    this.invitationB2bPartnerService.rejectInvitation()
        .then((response) => {
          this.currentInvitationStep = this.invitationStep.invitationB2bRejected;
        }).catch((error) => {
          if (error.error.error.code === 'object_not_found') {
            this.notificationService.error(translate('Cette invitation n\'est plus valide ou n\'existe plus.'));
          } else {
            this.configService.displayErrors(error);
          }
        })
        .finally(() => {
          this.rejectLoading = false;
        });
  }

  acceptInvitation(): void {
    this.acceptLoading = true;
    this.invitationB2bPartnerService.acceptInvitation()
        .then((response) => {
          this.partnershipId = response.data;
          this.currentInvitationStep = this.invitationStep.invitationB2bAccepted;
        }).catch((error) => {
          if (error.error.error.code === 'object_not_found') {
            this.notificationService.error(translate('Cette invitation n\'est plus valide ou n\'existe plus.'));
          } else {
            this.configService.displayErrors(error);
          }
        })
        .finally(() => {
          this.acceptLoading = false;
        });
  }

  openFaq(id: number) {
    const myEvent = new CustomEvent('openSupportModuleFaq', {detail: {id}});
    document.dispatchEvent(myEvent);
  }

  invitationResent(): void {
    this.currentInvitationStep = this.invitationStep.invitationB2bInvitationResent;
  }
}
